import React, { useState } from "react";
import styles from "../scss/PatientFi.module.scss";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { Box } from "../../../../../shared/Box/Box";
import { Modal } from "../../../../../shared/Modal/Modal";
import { Button } from "../../../../../shared/Button/Button";
import PatientFiIframe from "./PatientFiIframe.js/PatientFiIframe";

const RegisterContainer = ({ links }) => {
  const { tSettings } = useAppTranslation.Settings();

  const [showModal, setShowModal] = useState(false);

  return (
    <Box>
      <div className={styles.registerContainer}>
        <div className={styles.findApiContainer}>
          <h1>{tSettings("patientFiIntegration.connect.title")}</h1>
          <ol className={styles.findApiContainerList}>
            <li>{tSettings("patientFiIntegration.connect.step1")}</li>
            <li>{tSettings("patientFiIntegration.connect.step2")}</li>
            <li>{tSettings("patientFiIntegration.connect.step3")}</li>
            <li>{tSettings("patientFiIntegration.connect.step4")}</li>
          </ol>
        </div>
        <div className={styles.findApiContainer}>
          <h1>{tSettings("patientFiIntegration.enroll.title")}</h1>
          <ol className={styles.findApiContainerList}>
            <li>
              {tSettings("patientFiIntegration.enroll.step1")}
              <a
                href={"https://patientfi.com/aesthetic-record/"}
                target="_blank"
                rel="noopener noreferrer"
              >
                {tSettings("patientFiIntegration.enroll.step1Link")}
              </a>
            </li>
            <li>{tSettings("patientFiIntegration.enroll.step2")}</li>
          </ol>
        </div>
      </div>
      <h1>
        {tSettings("patientFiIntegration.help")}{" "}
        <a
          href={
            "https://learn.aestheticrecord.com/en/collections/14770252-patientfi"
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here.
        </a>
      </h1>
      <Button onClick={() => setShowModal(true)}>
        {tSettings("patientFiIntegration.connectAccountButton")}
      </Button>
      {showModal && (
        <Modal isOpen onClose={() => setShowModal(false)}>
          <PatientFiIframe
            link={links.iframe}
            onClose={() => setShowModal(false)}
          />
        </Modal>
      )}
    </Box>
  );
};

export default RegisterContainer;
